import { initI18n } from './i18n'

const init = async () => {
  await initI18n()
}

export default init
